import { DateField } from "@/components/ui/date-field";
import { Label } from "@/components/ui/label";
import { Text } from "@/components/ui/text";
import { TimeField, type TimeFieldProps } from "@/components/ui/time-field";
import { useTranslation } from "react-i18next";
import { View } from "react-native";

type DateTimeRowProps = {
    label: string | React.ReactNode;
    dateValue?: string;
    onDateChange?: (value: string) => void;
    datePlaceholder?: string;
    dateTestID?: string;
    minimumDate?: Date;
    maximumDate?: Date;
    time?: TimeFieldProps;
    hint?: string;
    dateDisabled?: boolean;
    timeDisabled?: boolean;
};

export function DateTimeRow({
    label,
    dateValue = "",
    onDateChange,
    datePlaceholder,
    dateTestID,
    minimumDate,
    maximumDate,
    time,
    hint,
    dateDisabled = false,
    timeDisabled = false,
}: DateTimeRowProps) {
    const showDate = onDateChange != null || dateDisabled;
    const { t } = useTranslation();

    return (
        <View className="gap-1">
            <View className="flex-row items-center justify-between gap-3">
                {typeof label === "string" ? (
                    <Label className="shrink-0">{label}</Label>
                ) : (
                    label
                )}
                <View className="shrink-0 flex-row flex-nowrap items-center justify-end gap-2">
                    {showDate ? (
                        <DateField
                            value={dateValue}
                            onChange={onDateChange ?? (() => {})}
                            placeholder={datePlaceholder || t("ui.selectDate")}
                            minimumDate={minimumDate}
                            maximumDate={maximumDate}
                            testID={dateTestID}
                            disabled={dateDisabled}
                            label={label}
                        />
                    ) : null}
                    {time && <TimeField {...time} disabled={timeDisabled} />}
                </View>
            </View>
            {hint ? <Text variant="caption">{hint}</Text> : null}
        </View>
    );
}
